import axios from 'axios';
import AuthService from './authService';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});


// ✅ Gắn token tự động vào tất cả request nếu có
API.interceptors.request.use((config) => {
  const token = AuthService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==== AUTH ====
export const login = (email, password) =>
  API.post('/auth/login', { email, password });

export const register = (username, email, password, confirmPassword) =>
  API.post('/auth/register', { username, email, password, confirmPassword });

// ==== RESET PASSWORD ====
export const resetPassword = ({ token, password }) =>
  API.post('/auth/reset-password', { token, password });

// ==== TEACHERS ====
export const getAllTeachers = () => API.get('/teachers');

export const getTeacherById = (id) => API.get(`/teachers/${id}`);

export const addTeacher = (teacherData) => API.post('/teachers', teacherData);

export const updateTeacher = (id, updatedData) =>
  API.put(`/teachers/${id}`, updatedData);

export const deleteTeacher = (id) => API.delete(`/teachers/${id}`);

// ==== SCHEDULES ====
export const getAllSchedules = () => API.get('/schedules');

export const getScheduleById = (id) => API.get(`/schedules/${id}`);

export const addSchedule = (notificationsData) => API.post('/schedules', notificationsData);

export const updateSchedule = (id, updatedData) =>
  API.put(`/schedules/${id}`, updatedData);

export const deleteSchedule = (id) => API.delete(`/schedules/${id}`);

// ==== NOTIFICATIONS ====

export const getAllNotifications = () => API.get('/notifications');

export const getNotificationById = (id) => API.get(`/notifications/${id}`);

/**
 * Gửi thông báo mới, có thể kèm theo file.
 * @param {FormData|Object} data - Dữ liệu thông báo, có thể là FormData nếu kèm file.
 */
export const addNotification = (data) =>
  API.post('/notifications', data, {
    headers: {
      'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/json',
    },
  });

/**
 * Cập nhật thông báo (nếu cần dùng)
 * @param {string} id - ID của thông báo
 * @param {FormData|Object} data - Dữ liệu cập nhật
 */
export const updateNotification = (id, data) =>
  API.put(`/notifications/${id}`, data, {
    headers: {
      'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/json',
    },
  });

/**
 * Xoá thông báo
 */
export const deleteNotification = (id) => API.delete(`/notifications/${id}`);

// ==== PROFILE ====
export const getProfile = () => API.get('/auth/profile');

export const updateProfile = (profileData) => API.put('/auth/profile', profileData);

// ==== CONTACT ====
export const sendContactMessage = (contactData) => API.post('/contact', contactData);

// ==== FORGOT PASSWORD ====
export const requestPasswordReset = (email) =>
  API.post('/auth/request-reset', { email });

export const changePassword = ({ currentPassword, newPassword }) =>
  API.post('/auth/change-password', { currentPassword, newPassword });
